import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteSuccessMessage } from "../../../Messages/successMessages";
import { bidPackUrls } from "../../../URL/ApplicationUrls";
import { bidPackObjectName } from "../BidPack";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useDeleteBidPack = (id: number | string | undefined) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (bidPackId: number | string | undefined) => {
      await axios.delete(bidPackUrls.apiUrlForBidPackWithId(bidPackId));
    },
    onSuccess: async () => {
      toast.success(deleteSuccessMessage(id, bidPackObjectName));
      navigate(bidPackUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
